import React from 'react';
import Alert from '../../../Helper/SimpleAlert/alert';
import RouteHeader from '../RouteHeader/routeHeader';
import Card from '../../../Helper/CardWrapper/cardWrapper';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {addAlbums, DeleteUserOwnFeed, fetchAlbum} from '../../../Actions/albumActions';
import ContentGrid from '../../../Helper/gridWrapper/gridWrapper';
import AlbumWebView from './albumWebView';
import AlbumAppView from './albumAppView';
import AppWrapper from '../../../Helper/AppWrapper/appWrapper';
import ErrorComponent from '../../../Helper/ErrorComponent/errorComponent';

class Album extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: '',
            firstName: '',
            feedId: '',
            latitude: '',
            feedType: '',
            postComment: '',
            longitude: '',
            feedSendType: '',
            jsonObject: {},
            showError: false,
            alertMessage: "",
            Msg: "",
            showAlert: false,
        }
    }

    componentDidMount() {
        let {user} = this.props;
        this.setState({
            userId: user.results.AppUser.UserId,
            latitude: user.results.AppUser.Latitude,
            firstName: user.results.AppUser.FirstName,
            feedType: 'LocalFeed',
            postComment: '',
            longitude: user.results.AppUser.Longitude,
            feedSendType: 'LocalFeed'
        }, () => {
            this.setInitial()
        });
    }

    setInitial = () => {
        let {userId, latitude, longitude} = this.state;
        this.props.fetchAlbum({UserId: userId, PageSize: 30, PageNumber: 1, Latitude: latitude, Longitude: longitude});
    };

    deleteImageFeedId = () => {
        let {feedId, userId} = this.state;
        this.props.DeleteUserOwnFeed({FeedId: feedId, UserId: userId});
    };

    checkFormat = (url) => {
        let arr = url.split(',');
        return arr[arr.length - 1];
    };

    checkBase64 = (url) => {
        let arr = url[0].split(';');
        let col = arr[0].split(':');
        let row = col[col.length - 1].split('/');
        return row[0];
    };

    addImages = (data) => {
        let {latitude, feedType, postComment, longitude, feedSendType, showError, alertMessage} = this.state;
        if (data.files.type.startsWith('image/') || data.files.type.startsWith('video/')) {
            (this.checkBase64(data.data)) === 'image' ?
                this.setState({
                    jsonObject: {
                        'UserId': this.props.user.results.AppUser.UserId,
                        'Latitude': latitude,
                        'FeedType': feedType,
                        'PostComment': postComment,
                        'Longitude': longitude,
                        'Image': this.checkFormat(data.data[0]),
                        'FeedSendType': feedSendType,
                        'isImage': 'YES',
                        'isVideo': 'NO',
                        'friendIdList': "",
                        'phoneContactNameList': "",
                        'locationAddress': "",
                        'placeId': "",
                        'sharedWithId': "",
                        'placePhone': "",
                        'placeWebsite': "",
                        'sendFeedType': ""
                    }
                }, () => {
                    this.callApi();
                })
                :
                this.setState({
                    jsonObject: {
                        'UserId': this.props.user.results.AppUser.UserId,
                        'Latitude': latitude,
                        'FeedType': feedType,
                        'PostComment': postComment,
                        'Longitude': longitude,
                        'Image': this.checkFormat(data.data[0]),
                        'FeedSendType': feedSendType,
                        'isImage': 'NO',
                        'isVideo': 'YES',
                        'friendIdList': "",
                        'phoneContactNameList': "",
                        'locationAddress': "",
                        'placeId': "",
                        'sharedWithId': "",
                        'placePhone': "",
                        'placeWebsite': "",
                        'sendFeedType': ""
                    }
                }, () => {
                    this.callApi();
                })
        } else {
            showError = true
            alertMessage = "Invalid file type.Please select Images or Videos only.";
        }
        this.setState({showError, alertMessage});
    };

    callApi = () => {
        let {jsonObject} = this.state;
        this.props.addAlbums(jsonObject).then((data) => {
            if (data.results.ResponseCode)
                this.showAlert("Image Added successfully.");
        });
    };
    showAlert = (msg) => {
        let {showAlert} = this.state;
        showAlert = !showAlert;
        let Msg = msg
        this.setState({showAlert, Msg});
    };
    onUpload = (data, message) => {
        message === 'Delete' ?
            this.setState({
                feedId: data.data
            }, () => {
                this.deleteImageFeedId();
            })
            :
            this.addImages(data);
    };
    showError = (Msg) => {
        this.setState({
            showError: !this.state.showError,
            alertMessage: Msg ? Msg : ""
        });
    };

    render() {
        const { user } = this.props;
        const {showError, alertMessage, showAlert} = this.state;
        return (
            <div>
                {showError && <ErrorComponent clickMethod={this.showError} msg={alertMessage}/>}
                <div className='container-div'>
                    <Alert showSuccess={showAlert} showError={false} Msg={this.state.Msg} onClose={this.showAlert}/>
                    <ContentGrid
                        header={
                            user.results.BusinessUser.IsFirstVisit && JSON.parse(user.results.BusinessUser.IsFirstVisit)['My Album'] ?
                                <RouteHeader title={'My Album'}
                                             text={'Upload your favorite photos about your business. A picture is worth a thousand words.'}
                                /> : <span/>
                        }
                        content={
                            <Card content={
                                <AlbumWebView
                                    onUpload={this.onUpload}
                                    showGotIt={user.results.BusinessUser.IsFirstVisit && JSON.parse(user.results.BusinessUser.IsFirstVisit)['My Album']}
                                    callApi={this.callApi}
                                    showError={this.showError}
                                />
                            }/>
                        }
                        appView={
                            <AppWrapper tab={2} header={'Live Preview'} subheader={user.results.AppUser.FirstName}
                                        content={
                                            <AlbumAppView/>
                                        }
                            />
                        }
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        albums: state.albums,
        user: state.loginResponse
    }
};
const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        addAlbums, fetchAlbum, DeleteUserOwnFeed
    }, dispatch)
};
export default connect(mapStateToProps,matchDispatchToProps)(Album);